import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common';

@Component({
  selector: 'app-supplier-round-list-ssy1230detail-edit',
  templateUrl: 'supplier-round-list-ssy1230detail-edit.component.html'
})
export class SupplierRoundListSsy1230detailEditComponent implements OnInit {

    viewState = ViewState;
  
	constructor() { }

	ngOnInit (): void {
		//Auth.checkAuthorization('');
	}
	
	// custom-start

	
	
  
	// custom-end

	

}
